import { Controller } from 'stimulus';
import Vue from 'vue';
import store from '@/cart/store';
import Cart from '@/cart/Cart.vue';

class CartController extends Controller {
  connect() {
    const i18n = this.data.get('i18n');
    const routes = this.data.get('routes');
    const settings = this.data.get('settings');

    Vue.mixin({
      data() {
        return {
          get i18n() {
            return JSON.parse(i18n);
          },

          get routes() {
            return JSON.parse(routes);
          },

          get settings() {
            return JSON.parse(settings);
          },
        };
      },
    });

    this.instance = new Vue({
      el: this.element,
      store,
      components: {
        'base-component': Cart,
      },
      template: '<base-component />',
    });
  }
}

CartController.targets = [];

export default CartController;
